export default __webpack_public_path__ + "static/media/teacher-knowledge-and-skill.5eca3e8e.png";